export default __webpack_public_path__ + "static/media/user-solid.4e9e99c1.svg";